import request from '../utils/request'
export const getYaxSuggestNewsList = data =>
    request({
        url: '/yax/v1/yaxNewsApi/getYaxSuggestNewsList',
        method: "POST",
        data
    });
export const getYaxNewsList = data =>
    request({
        url: '/yax/v1/yaxNewsApi/getYaxNewsList',
        method: "POST",
        data
    });
export const getYaxNewsInfo = data =>
    request({
        url: '/yax/v1/yaxNewsApi/getYaxNewsInfo',
        method: "POST",
        data
    });
export const getXieYiInfo = data =>
    request({
        url: '/basic/init/sysApi/getXieYiInfo',
        method: "POST",
        data
    });
export const getBxxyCourseApiList = data =>
    request({
        url: '/BxxyCourseApi/getBxxyCourseApiList',
        method: "POST",
        data
    });
export const bxxyCourseLoginApi = data =>
    request({
        url: '/BxxyCourseApi/bxxyCourseLoginApi',
        method: "POST",
        data
    });
